import { defineStore } from "pinia";
import { CourseInstance, CourseInstanceFinder, CourseInstanceStatus, CourseParticipationOutcome, CourseParticipationOutcomeFinder } from '@/learning/instances/models';
import { courseService } from './service';
import { instancesService } from '@/learning/instances/instancesService';
import { templatesService } from "../../learning/templates/TemplatesService";
import { registriesService } from '@/learning/registries/registriesService';
import { ApiPagedResult, SortingOrder, usePlatformApi } from "@k-digitale/kappa";
import { SaveCourseParticipationRequestListItemRequest, SaveExternalCourseParticipationRequest } from "./requests";
import dayjs from "dayjs";
import { CourseTemplate, CourseTemplateFinder, CourseTemplateStatus } from "@/learning/Templates/Models";
import { learningWrappersService } from "../../services/learningWrappers/LearningWrappersServices";
import { CourseInstanceWrapper } from "@/services/learningWrappers/Models";
import { SaveCourseParticipationRequest } from "@/learning/instances/Requests";

const { execApiCall } = usePlatformApi();
export interface ModuleCourseState {
  loadingCompanyOutcomes: boolean,
  loadingStartingCourses: boolean,
  loadingCourses: boolean,
  loadingOtherCourses: boolean,
  loadingCourse: boolean,
  startingCourses: CourseInstance[]
  courses: CourseTemplate[]
  companyOutcomes: CourseParticipationOutcome[]
}

export const useCourseStore = defineStore('module-course-store', {
  state: () => ({
    loadingCompanyOutcomes: false,
    loadingStartingCourses: false,
    loadingCourses: false,
    loadingCourse: false,
    loadingOtherCourses: false,
    startingCourses:[] as CourseInstance[],
    courses: [],
    companyOutcomes: [],
  } as ModuleCourseState),

  getters: {
      //
  },

  actions: {
      async loadStartingCourses(pageIndex:number, pageSize: number) {

          const finder = {
              status: CourseInstanceStatus.StudentsSigninIn,
              queryRelations: true,
              startAfterDate: new Date(),
              sortField: "startDate",
              sortOrder: SortingOrder.Ascending,
              hideOldCourses: true,
              pageIndex: pageIndex,
              pageSize: pageSize,
              excludeFullCourses: true,

          } as CourseInstanceFinder;

          const courses = await execApiCall(courseService.getStartingCourses(finder));
          if(courses && courses.items && courses.items.length)
          {
              this.startingCourses = courses.items;
          } else{
              this.startingCourses = [];
          }
      },

      async saveCourseParticipationRequestsSave(request : SaveCourseParticipationRequestListItemRequest[]) : Promise<boolean> {
        return await execApiCall(instancesService.saveCourseParticipationRequestList(request));
      },
      async saveCourseParticipationSave(request : SaveExternalCourseParticipationRequest[]) : Promise<boolean> {
        return await execApiCall(instancesService.saveCourseParticipationList(request));
      },
      async getCompanyCourseOutcomesByFinder(companyId: string, finder : CourseParticipationOutcomeFinder) : Promise<CourseParticipationOutcome[]> {
        this.loadingCompanyOutcomes = true;
        const courseParticipationsResponse = await registriesService.getCourseParticipationOutcomesWithActualStudents(companyId, finder);
        this.loadingCompanyOutcomes = false;
        if(courseParticipationsResponse && courseParticipationsResponse.items){
          this.companyOutcomes = courseParticipationsResponse.items;
        return courseParticipationsResponse.items;
        }
        return [];
      },

      async getStartingCourses(finder : CourseInstanceFinder) : Promise<CourseInstance[]> {
        finder.startAfterDate = dayjs().utc(true).toDate();
        finder.status = CourseInstanceStatus.StudentsSigninIn;
        finder.excludeFullCourses = true;

        this.loadingStartingCourses = true;
        const startingCoursesResponse = await instancesService.getCourseInstancesByFinder(finder);
        this.loadingStartingCourses = false;
        if(startingCoursesResponse && startingCoursesResponse.items){
          this.startingCourses = startingCoursesResponse.items;
          return startingCoursesResponse.items;
        }
        return [];
      },

      async getStartingCoursesWrapper(finder : CourseInstanceFinder) : Promise<CourseInstanceWrapper[]> {
        finder.startAfterDate = dayjs().utc(true).toDate();
        finder.status = CourseInstanceStatus.StudentsSigninIn;
        finder.excludeFullCourses = true;

        this.loadingStartingCourses = true;
        const startingCoursesResponse = await learningWrappersService.getCourseInstancesWrappersByFinder(finder);
        this.loadingStartingCourses = false;
        if(startingCoursesResponse && startingCoursesResponse.items){
          this.startingCourses = startingCoursesResponse.items;
          return startingCoursesResponse.items;
        }
        return [];
      },

      async getAllCourses(finder: CourseTemplateFinder) : Promise<ApiPagedResult<CourseTemplate>> {
        finder.status = CourseTemplateStatus.Completed;
        finder.showRelatedToPimOnly = true;
        this.loadingCourses = true;
        const coursesResponse = await templatesService.getCourseTemplatesByFinder(finder);
        this.loadingCourses = false;
        if(coursesResponse && coursesResponse.items){
          this.courses = coursesResponse.items;
          return coursesResponse;
        }
        return {} as ApiPagedResult<CourseTemplate>;
      },

      async getOtherCourses(finder: CourseTemplateFinder) : Promise<ApiPagedResult<CourseTemplate>> {
        finder.status = CourseTemplateStatus.Completed;
        finder.showRelatedToPimOnly = false;
        this.loadingOtherCourses = true;
        const coursesResponse = await templatesService.getCourseTemplatesByFinder(finder);
        this.loadingOtherCourses = false;
        if(coursesResponse && coursesResponse.items){
          this.courses = coursesResponse.items;
          return coursesResponse;
        }
        return {} as ApiPagedResult<CourseTemplate>;
      },

      async getCourse(id: string) : Promise<CourseTemplate> {
        this.loadingCourse = false;
        const courseResponse = await templatesService.getCourseTemplate(id);
        this.loadingCourse = true;
        return courseResponse;

      }
  }
})